
import uiMixin from '@/mixins/uiMixin';

export default {
  mixins: [uiMixin],
  props: {
    steps: {
      required: true,
      type: Array,
      default: () => [],
    },
    title: {
      required: true,
      type: String,
      default: () => '',
    },
    subtitle: {
      required: true,
      type: String,
      default: () => '',
    },
    icon: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  methods: {
    toAppsManagerPage() {
      if (this.icon) {
        this.$router.push('/apps-manager/getting-started');
      }
    },
  },
  watch: {
    steps: {
      handler() {
        this.isLoaded = true;
      },
      immediate: true, // This ensures that the handler runs immediately when the component is created
    },
  },
};
